import styled from "@emotion/styled";
import TableRow from "@material-ui/core/TableRow";
import { units } from "../../../../types/units";
import TableCell from "@material-ui/core/TableCell";
import { makeStyles } from "@material-ui/core/styles";
import { BASE_COLORS } from "../../../../emotion-theme";

export const useStyles = makeStyles({
  table: {
    minWidth: 750,
    marginBottom: 30,
  },
});
export const StyledTableRow = styled(TableRow)`
  cursor: pointer;
  ${units({
    textDecoration: "none",
    "&:hover": {
      border: "solid 1.5px skyBlue",
      backgroundColor: "lightBlue",
    },
    "&:focus": {
      border: `solid 1.5px ${BASE_COLORS.navyBlue}`,
    },
  })}
`;

export const StyledTableCell = styled(TableCell)`
  padding: ${(props) => (props.scope === "header" ? "0 1rem" : "1rem")};
  color: ${(props) => (props.scope === "vacant" ? props.theme.colors.slightLightGray : "black")};
  background-color: ${(props) =>
    props.scope === "vacant" ? props.theme.colors.lighterGrey : "transparent"};
  border-bottom: ${(props) => (props.scope === "dummy" ? "none" : "normal")};
  ${units({
    fontSize: "small",
  })};
  max-width: ${(props) => (props.scope === "name" ? "300px" : "none")};
  min-width: ${(props) => (props.scope === "name" ? "100px" : "none")};
`;
